import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import { breakpoints } from '@utils/breakpoints'

const FontsSection = () => {
  return (
    <Section>
      <SectionTitle>Fonts</SectionTitle>
      <LoginTitle>LoginTitle - 78px</LoginTitle>
      <LargeTitle>LargeTitle - 34px</LargeTitle>
      <Title1>Title1 - 28px</Title1>
      <Title2>Title2 - 22px</Title2>
      <Title3>Title3 - 20px</Title3>
      <Headline>Headline - 17px</Headline>
      <Body>Body - 17px</Body>
      <Callout>Callout - 16px</Callout>
      <Subheadline>Subheadline - 15px</Subheadline>
      <Footnote>Footnote - 13px</Footnote>
      <Caption1>Caption1 - 12px</Caption1>
      <Caption2>Caption2 - 11px</Caption2>
    </Section>
  )
}

export default FontsSection

const Section = styled(View)`
  padding: 24px;
  border-color: ${(props) => props.theme.colors.disable};
  border-bottom-width: 1px;
  border-style: solid;

  @media only screen and (min-width: ${breakpoints.phone}px) {
    padding: 24px 48px;
  }
`
const SectionTitle = styled(Text)`
  margin-bottom: 15px;
  text-decoration: underline;
  ${(props) => props.theme.fonts.LargeTitle};
`

const LoginTitle = styled(Text)`
  ${(props) => props.theme.fonts.LoginTitle};
`
const LargeTitle = styled(Text)`
  ${(props) => props.theme.fonts.LargeTitle};
`
const Title1 = styled(Text)`
  ${(props) => props.theme.fonts.Title1};
`
const Title2 = styled(Text)`
  ${(props) => props.theme.fonts.Title2};
`
const Title3 = styled(Text)`
  ${(props) => props.theme.fonts.Title3};
`
const Headline = styled(Text)`
  ${(props) => props.theme.fonts.Headline};
`
const Body = styled(Text)`
  ${(props) => props.theme.fonts.Body};
`
const Callout = styled(Text)`
  ${(props) => props.theme.fonts.Callout};
`
const Subheadline = styled(Text)`
  ${(props) => props.theme.fonts.Subheadline};
`
const Footnote = styled(Text)`
  ${(props) => props.theme.fonts.Footnote};
`
const Caption1 = styled(Text)`
  ${(props) => props.theme.fonts.Caption1};
`
const Caption2 = styled(Text)`
  ${(props) => props.theme.fonts.Caption2};
`
